import { createSortAtom } from '@/common/filtering/store.ts';
import { toSortSelectionString } from '@pac/filter';
import {
  SALES_ORDER_DEFAULT_SORT,
  SALES_ORDER_SORT_COLUMNS,
} from '@pac/filter/shared/sales-orders';

export const salesOrderSortAtom = createSortAtom(
  SALES_ORDER_SORT_COLUMNS,
  toSortSelectionString<typeof SALES_ORDER_SORT_COLUMNS>(
    SALES_ORDER_DEFAULT_SORT,
  ),
);
